import { AppUtils } from './../../app.utils';
import { AppService } from './../../app.service';
import {
  Component, OnInit, Input, HostListener, ElementRef,
  ViewEncapsulation, OnDestroy, Output, EventEmitter, Renderer2
} from '@angular/core';
import { LightScrollBarOptions, CompanyMenuItems } from '../shared.model';
import { SharedService } from './../shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { PermissionService } from '../permissions/permissions.service';

@Component({
  selector: 'ba-side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['./side-navigation.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SideNavigationComponent implements OnInit, OnDestroy {
  dropdownMenu: boolean;
  isSwitchUser = false;
  navigation = 'tab-menu';
  lightScrollbarOptions = LightScrollBarOptions;
  companyName: any;
  currentRoute: any;
  toggleSettingsMenu: boolean;
  toggleCashierMenu: boolean;
  toggleReportsMenu: boolean;
  toggleTruViewBalanceMenu: boolean;
  toggleDataPointReportingMenu: boolean;
  toggleCustomReportMenu: boolean;
  toggleAnalyticsMenu: boolean;
  toggleSalesMenu = false;
  toggleCompanyMenu = false;
  imageUrl: any;
  adminRole: boolean;
  role: string;
  permissions: Array<any> = [];
  accessGroupPermissions: Array<any> = [];
  companyData: any;
  imageSubscription: Subscription;
  companyDataSubscription: Subscription;
  reloadCompanyMenuItems: Subscription;
  selectedCompanyMenu: CompanyMenuItems[];
  companyMenuItems: CompanyMenuItems[];
  updateLocationCount: Array<any> = [];
  defaultSelectedCompanyMenu = false;
  textFilter: any;
  currentRouteUrl = null;
  toggleDprStore: boolean = false;
  toggleDprTerminal: boolean = false;
  toggleDprCashier: boolean = false;
  toggleBalancingReport: boolean = false;
  toggleDoubleUpReport: boolean = false;
  matchCompanyName: string = '';
  toggleDigitalReceiptsMenu: boolean;
  @Input() openSideNav: boolean;
  @Output() updateNavigationState = new EventEmitter();

  constructor(
    public renderer: Renderer2,
    public elementRef: ElementRef,
    public sharedService: SharedService,
    public route: ActivatedRoute,
    public router: Router,
    public translate: TranslateService,
    public appService: AppService,
    public permissionService: PermissionService,
    public appUtils: AppUtils
  ) {
    this.dropdownMenu = false;
    this.adminRole = this.permissionService.isAdmin;
    this.permissions = this.permissionService.getCurrentPermissions();
    document.addEventListener('click', this.offClickHandler.bind(this));
  }

  ngOnInit() {
    this.getUserCompany();
    this.getSubscriptionData();
    const temp: any = JSON.parse(localStorage.getItem('loggedInUser'));
    this.role = temp['role'];
    this.accessGroupPermissions = temp?.accessGroupPermissions ? temp.accessGroupPermissions : [];
    if (temp.isSwitchBackVisible) {
      if (JSON.parse(localStorage.getItem('switchUserFlag'))) {
        localStorage.removeItem('currentRouteUrl');
        localStorage.removeItem('switchUserFlag');
      }
      this.isSwitchUser = false;
    }
    this.currentRouteUrl = localStorage.getItem('currentRouteUrl');
    if (this.route.firstChild && this.route.firstChild.snapshot) {
      if (this.route.firstChild && this.route.firstChild.snapshot) {
        this.currentRoute = (this.route.firstChild.snapshot.children[0]?.data?.topHeader === undefined) ? 'COMMON.OVERVIEW' :
          this.route.firstChild.snapshot.children[0]?.data?.topHeader;
      }
    }
    this.openedMenu();
    this.defaultSelectedCompanyMenu = true;
    this.prepareCompanyMenuAndFilter();
  }

  ngOnDestroy() {
    if (this.imageSubscription) { this.imageSubscription.unsubscribe(); }
    if (this.companyDataSubscription) { this.companyDataSubscription.unsubscribe(); }
    if (this.reloadCompanyMenuItems) { this.reloadCompanyMenuItems.unsubscribe(); }
  }

  prepareCompanyMenuAndFilter() {
    this.companyMenuItems = [
      { label: 'All Locations', id: 1, isLocation: false, header: '', levelHeader: 'All Locations', selected: false }
    ];
    this.prepareGlobalFilter();
    this.prepareCompanyMenu();
  }

  /**
   * To get subscribed data from components
   */
  getSubscriptionData() {
    this.imageSubscription = this.appService.updatedCompanyLogo$
      .subscribe((imageUrl) => {
        this.imageUrl = imageUrl;
      });
    this.companyDataSubscription = this.appService.updatedCompanyData$
      .subscribe((data) => {
        this.companyData = data;
        this.companyName = data.name;
      });
    this.reloadCompanyMenuItems = this.appService.companyMenu$
      .subscribe((isReload) => {
        if (isReload) {
          this.prepareCompanyMenuAndFilter();
        }
      });
  }

  toggleCompanyOptionMenu() {
    this.toggleCompanyMenu = !this.toggleCompanyMenu;
  }

  // To update the companyMenuItems 
  updateCompanyMenuItems() {
    this.companyMenuItems = this.companyMenuItems.map(item => {
      const matchedItem = this.selectedCompanyMenu.find(selected => selected.label === item.label);
      return matchedItem ? { ...item, ...matchedItem } : item;
    });
  }

  prepareCompanyMenu() {
    if (localStorage.getItem('selectedMenuItem')) {
      this.selectedCompanyMenu = JSON.parse(localStorage.getItem('selectedMenuItem'));
      this.updateCompanyMenuItems();
    } else {
      this.selectedCompanyMenu = [{ label: 'All Locations', id: 1, isLocation: false, levelHeader: 'All Locations', header: '', selected: true }];
    }
    this.updateCountFun();
  }

  listSelection(listObj: any) {
    const index = this.selectedCompanyMenu?.findIndex(menuTtem => menuTtem.label === listObj['label']);
    if (index === -1) {
      this.selectedCompanyMenu.push(listObj);
    }
    this.selectedCompanyMenu = this.selectedCompanyMenu.map(menuTtem => {
      const isMatched = menuTtem.label === listObj.label;
      const lengthFlag = this.selectedCompanyMenu.length > 1 && this.updateLocationCount.length > 1;
      if (isMatched && !menuTtem['selected']) {
        menuTtem['selected'] = !menuTtem['selected']
      } else if (isMatched && menuTtem['selected'] && lengthFlag) {
        menuTtem['selected'] = !menuTtem['selected']
      }
      return menuTtem;
    });
    this.updateCountFun();
  }

  updateCountFun() {
    this.updateLocationCount = this.selectedCompanyMenu.filter(function (obj) {
      return obj.selected !== false;
    });
  }

  selectedList(list: Object) {
    if (this.selectedCompanyMenu[0].levelHeader === list['levelHeader']) {
      this.listSelection(list);
    } else {
      this.selectedCompanyMenu = [];
      this.companyMenuItems.forEach(item => {
        item.selected = false;
      });
      this.listSelection(list);
    }
    this.updateCompanyMenuItems();

    localStorage.setItem('selectedMenuItem', JSON.stringify(this.selectedCompanyMenu));
    this.defaultSelectedCompanyMenu = false;
  }

  updateCompanyMenu() {
    const locationResponseData: any = [];
    let selectedLocationIds: any = [];
    const levelsFilter = JSON.parse(localStorage.getItem('levelsFilter'));
    const locations = levelsFilter['locations'] ? levelsFilter['locations'] : '';
    let locationResData = levelsFilter['locationResponseData'];
    this.textFilter = '';
    if (this.updateLocationCount[0]['label'] === 'All Locations') {
      locationResData.forEach(regLoc => {
        selectedLocationIds.push(regLoc['reg_loc_id']);
      });
      this.handleLocalStorageLocationItems(locationResData, levelsFilter, locationResponseData, selectedLocationIds);
    } else {
      if (this.updateLocationCount[0]['isLocation']) {
        this.updateLocationCount.forEach(element => {
          locations.forEach(loc => {
            const id = loc.reg_loc_id && loc.reg_loc_id !== null ? loc.reg_loc_id : loc.id;
            if (element.id === id) {
              const location = {};
              location['location_id'] = loc['id'];
              location['reg_loc_id'] = loc['reg_loc_id'];
              location['name'] = loc['name'];
              location['depth'] = 0;
              locationResponseData.push(location);
            }
          });
        });
        this.updateLocationCount.forEach(loc => {
          selectedLocationIds.push(loc['id']);
        });
      } else {
        this.updateLocationCount.forEach(reg => {
          const finalObj = this.getRegionAssignedLocations(reg, levelsFilter);
          finalObj['assignedLocs'].forEach((assignedLoc: any) => {
            locationResponseData.push(assignedLoc);
          });
          finalObj['selectedLocIds'].forEach((selectedLocId: any) => {
            selectedLocationIds.push(selectedLocId);
          });
        });
      }
      selectedLocationIds = this.appUtils.getParentRegionLocationId(selectedLocationIds);
      levelsFilter['isGlobalFilter'] = true;
      this.handleLocalStorageLocationItems([], levelsFilter, locationResponseData, selectedLocationIds)
    }
    this.reloadComponent();
  }

  /**
   * localstorage item while updating company menu
   */
  handleLocalStorageLocationItems(locationResData, levelsFilter, locationResponseData, selectedLocationIds) {
    if (locationResData.length) {
      localStorage.setItem('locationResponseData', JSON.stringify(locationResData));
    }
    else {
      localStorage.setItem('levelsFilter', JSON.stringify(levelsFilter));
      localStorage.setItem('locationResponseData', JSON.stringify(locationResponseData));
    }
    localStorage.setItem('selectedLocationId', JSON.stringify(selectedLocationIds));
    localStorage.setItem('selectedLocationIdOverview', JSON.stringify(selectedLocationIds));
    localStorage.setItem('selectedLocationIdStoreOverview', JSON.stringify(selectedLocationIds));
    localStorage.setItem('selectedLocationIdTerminal', JSON.stringify(selectedLocationIds));
    localStorage.setItem('selectedLocationIdDepartment', JSON.stringify(selectedLocationIds));
    localStorage.setItem('selectedLocationIdStoreDepartment', JSON.stringify(selectedLocationIds));
    localStorage.setItem('selectedLocationIdItems', JSON.stringify(selectedLocationIds));
    localStorage.setItem('selectedLocationIdTender', JSON.stringify(selectedLocationIds));
    localStorage.setItem('selectedLocationIdStoreTender', JSON.stringify(selectedLocationIds));
    localStorage.setItem('selectedLocationIdSummary', JSON.stringify(selectedLocationIds));
    localStorage.setItem('selectedLocationIdCashiers', JSON.stringify(selectedLocationIds));
    localStorage.setItem('selectedLocationIdTransaction', JSON.stringify(selectedLocationIds));
    localStorage.setItem('selectedLocationIdAnalytics', JSON.stringify(selectedLocationIds));
    localStorage.removeItem('reportTabData');
    localStorage.removeItem('reportListTabData');
    localStorage.removeItem('itemDepartmentLocId');
    localStorage.removeItem('departmentLocId');
    localStorage.removeItem('selectedGroupId');
    localStorage.removeItem('selectedItemGroupId');
    localStorage.removeItem('doubleUpReportDropDown');
    localStorage.setItem('selectedLocationIdsDoubleUp', JSON.stringify(selectedLocationIds));
    localStorage.setItem('selectedLocationIdsLaneReboot', JSON.stringify(selectedLocationIds));
    localStorage.setItem('selectedLocIdsDigitalReceipt', JSON.stringify(selectedLocationIds));
  }

  reloadComponent() {
    let currentUrl = '';
    currentUrl = this.router.url;
    this.toggleCompanyOptionMenu();
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  /**
   * Helper to set toggles for a specific menu
   */
  private setMenuToggles({
    sales = false,
    settings = false,
    reports = false,
    customReport = false,
    truViewBalance = false,
    dataPointReporting = false,
    cashier = false,
    analytics = false,
    balancingReport = false,
    doubleUpReport = false,
    digitalReceipts = false
  }) {
    this.toggleSalesMenu = sales;
    this.toggleSettingsMenu = settings;
    this.toggleReportsMenu = reports;
    this.toggleCustomReportMenu = customReport;
    this.toggleTruViewBalanceMenu = truViewBalance;
    this.toggleDataPointReportingMenu = dataPointReporting;
    this.toggleCashierMenu = cashier;
    this.toggleAnalyticsMenu = analytics;
    this.toggleBalancingReport = balancingReport;
    this.toggleDoubleUpReport = doubleUpReport;
    this.toggleDigitalReceiptsMenu = digitalReceipts;
  }

  /**
   * Helper to handle navigation and toggles for access group permissions
   */
  private handleAccessGroupNavigation() {
    const perms = this.accessGroupPermissions;
    if (perms.includes('Sales Access Group')) {
      this.setMenuToggles({ sales: true });
      this.router.navigate(['/sales/locationItems']);
    } else if (perms.includes('Data Point Reporting Access Group')) {
      this.setMenuToggles({ dataPointReporting: true });
      this.toggleDprStore = true;
      this.router.navigate(['/data-point-reporting/store/overview']);
    } else if (perms.includes('Sheets Access Group')) {
      this.setMenuToggles({});
      this.router.navigate(['sheets']);
    } else if (perms.includes('Balancing Access Group')) {
      this.setMenuToggles({ truViewBalance: true, balancingReport: true });
      this.router.navigate(['/balancing/dashboard']);
    } else if (perms.includes('POS Reports Access Group')) {
      this.setMenuToggles({});
      this.router.navigate(['reports']);
    } else if (perms.includes('Digital Receipts')) {
      this.setMenuToggles({});
      this.router.navigate(['digital-receipts']);
    } else if (perms.includes('Cashiers Access Group')) {
      this.setMenuToggles({ cashier: true });
      this.router.navigate(['cashiers']);
    } else if (perms.includes('Transactions Access Group')) {
      this.setMenuToggles({});
      this.router.navigate(['transactions']);
    } else if (perms.includes('Custom Reports Access Group')) {
      this.setMenuToggles({ customReport: true });
      this.router.navigate(['/custom-report/tax-report']);
    } else if (perms.includes('Analytics Access Group')) {
      this.setMenuToggles({ analytics: true });
      this.router.navigate(['/analytics/query']);
    } else if (perms.includes('Company Setting')) {
      this.router.navigate(['/settings/companies']);
    } else if (perms.includes('Datapoint Setting')) {
      this.router.navigate(['/settings/dp-category']);
    } else if (perms.includes('Location Setting')) {
      this.router.navigate(['/settings/locations']);
    } else if (perms.includes('Users Setting')) {
      this.router.navigate(['/settings/users']);
    } else if (perms.includes('Connector Setting')) {
      this.router.navigate(['/settings/connectors']);
    } else if (perms.includes('Calendar Period Setting')) {
      this.router.navigate(['/settings/calendar-period']);
    } else if (perms.includes('Instacart Setting')) {
      this.router.navigate(['/settings/instacart']);
    } else if (perms.includes('Category Setting')) {
      this.router.navigate(['/settings/category']);
    } else if (perms.includes('Door Scan Solution')) {
      this.setMenuToggles({});
      this.router.navigate(['door-scan-solution']);
    }
  }


  openedMenu() {
    setTimeout(() => {
      // Map of route to toggles
      const routeToggles: { [key: string]: () => void } = {
        // Main menu routes
        'SIDE_NAVIGATION.USERS': () => this.setMenuToggles({ settings: true }),
        'COMMON.ROLES': () => this.setMenuToggles({ settings: true }),
        'SIDE_NAVIGATION.USERS_ROLES': () => this.setMenuToggles({ settings: true }),
        'SIDE_NAVIGATION.CONNECTORS': () => this.setMenuToggles({ settings: true }),
        'SIDE_NAVIGATION.COMPANY_SETTINGS': () => this.setMenuToggles({ settings: true }),
        'SIDE_NAVIGATION.COMPANIES': () => this.setMenuToggles({ settings: true }),
        'SIDE_NAVIGATION.ACCESS_GROUPS': () => this.setMenuToggles({ settings: true }),
        'SIDE_NAVIGATION.LOCATIONS': () => this.setMenuToggles({ settings: true }),
        'SIDE_NAVIGATION.DATA_POINT': () => this.setMenuToggles({ settings: true }),
        'SIDE_NAVIGATION.CALENDARPERIOD': () => this.setMenuToggles({ settings: true }),
        'SIDE_NAVIGATION.INSTACART': () => this.setMenuToggles({ settings: true }),
        'SIDE_NAVIGATION.CATEGORY': () => this.setMenuToggles({ settings: true }),
        'SIDE_NAVIGATION.PERMISSIONS': () => this.setMenuToggles({ settings: true }),
        'SIDE_NAVIGATION.ORGANIZATION_HIERARCHY': () => this.setMenuToggles({ settings: true }),
        [this.translate.instant('COMMON.SETTING_DETAIL')]: () => this.setMenuToggles({ settings: true }),
        // Submenu routes
        'COMMON.OVERVIEW': () => this.setMenuToggles({ sales: true }),
        'COMMON.DEPARTMENT': () => this.setMenuToggles({ sales: true }),
        'SIDE_NAVIGATION.ITEMS': () => this.setMenuToggles({ sales: true }),
        'ITEM_MOVEMENT.TENDERS.TENDER': () => this.setMenuToggles({ sales: true }),
        'COMMON.SUMMARY': () => this.setMenuToggles({ sales: true }),
        'SIDE_NAVIGATION.CASHIER_LIST': () => this.setMenuToggles({ cashier: true }),
        'SIDE_NAVIGATION.CASHIER_COUPONS': () => this.setMenuToggles({ cashier: true }),
        'SIDE_NAVIGATION.CASHIER_PERFORMANCE': () => this.setMenuToggles({ cashier: true }),
        'SIDE_NAVIGATION.CASHIER_SIGNED_ON': () => this.setMenuToggles({ cashier: true }),
        'SIDE_NAVIGATION.CASHIER_DEPARTMENT': () => this.setMenuToggles({ cashier: true }),
        'SIDE_NAVIGATION.SINGLE_LOC_REPORT': () => this.setMenuToggles({ reports: true }),
        'SIDE_NAVIGATION.MULTI_LOC_REPORT': () => this.setMenuToggles({ reports: true }),
        "SIDE_NAVIGATION.CUSTOMERS": () => this.setMenuToggles({ digitalReceipts: true }),
        "SIDE_NAVIGATION.SENT_RECEIPTS": () => this.setMenuToggles({ digitalReceipts: true }),
      };

      // Map of currentRouteUrl to toggles
      const urlToggles: { [key: string]: () => void } = {
        '/analytics/query': () => this.setMenuToggles({ analytics: true }),
        '/analytics/previousQuery': () => this.setMenuToggles({ analytics: true }),
        '/custom-report/tax-report': () => this.setMenuToggles({ customReport: true }),
        '/custom-report/aggregated-sales': () => this.setMenuToggles({ customReport: true }),
        '/balancing/dashboard': () => this.setMenuToggles({ truViewBalance: true }),
        '/balancing/reporting': () => this.setMenuToggles({ truViewBalance: true }),
        '/balancing/configuration': () => this.setMenuToggles({ truViewBalance: true }),
        '/balancing/daily-reporting': () => this.setMenuToggles({ truViewBalance: true, balancingReport: true }),
        '/balancing/weekly-reporting': () => this.setMenuToggles({ truViewBalance: true, balancingReport: true }),
        '/balancing/monthly-reporting': () => this.setMenuToggles({ truViewBalance: true, balancingReport: true }),
        '/cashiers/list': () => this.setMenuToggles({ cashier: true }),
        '/cashiers/signed-on': () => this.setMenuToggles({ cashier: true }),
        '/cashiers/performance': () => this.setMenuToggles({ cashier: true }),
        '/cashiers/coupons': () => this.setMenuToggles({ cashier: true }),
        '/cashiers/department': () => this.setMenuToggles({ cashier: true }),
        '/sales-v2/store/overview': () => { this.setMenuToggles({ dataPointReporting: true }); this.toggleDprStore = true; },
        '/sales-v2/store/department': () => { this.setMenuToggles({ dataPointReporting: true }); this.toggleDprStore = true; },
        '/sales-v2/store/tender': () => { this.setMenuToggles({ dataPointReporting: true }); this.toggleDprStore = true; },
        '/sales-v2/store/cashier': () => { this.setMenuToggles({ dataPointReporting: true }); this.toggleDprStore = true; },
        '/sales-v2/terminal/overview': () => { this.setMenuToggles({ dataPointReporting: true }); this.toggleDprTerminal = true; },
        '/sales-v2/terminal/department': () => { this.setMenuToggles({ dataPointReporting: true }); this.toggleDprTerminal = true; },
        '/sales-v2/terminal/tender': () => { this.setMenuToggles({ dataPointReporting: true }); this.toggleDprTerminal = true; },
        '/sales-v2/terminal/cashier': () => { this.setMenuToggles({ dataPointReporting: true }); this.toggleDprTerminal = true; },
        '/sales-v2/cashier/overview': () => { this.setMenuToggles({ dataPointReporting: true }); this.toggleDprCashier = true; },
        '/double-up-report/sales-metrics': () => { this.setMenuToggles({ doubleUpReport: true }); },
        '/double-up-report/item': () => { this.setMenuToggles({ doubleUpReport: true }); },
        '/double-up-report/transaction-item': () => { this.setMenuToggles({ doubleUpReport: true }); },
        '/double-up-report/transaction-detail': () => { this.setMenuToggles({ doubleUpReport: true }); },
        '/double-up-report/voucher': () => { this.setMenuToggles({ doubleUpReport: true }); },
        '/double-up-report/milk-incentive': () => { this.setMenuToggles({ doubleUpReport: true }); },
        '/digital-receipts/sent-receipts': () => { this.setMenuToggles({ digitalReceipts: true }); },
        '/digital-receipts/customers': () => { this.setMenuToggles({ digitalReceipts: true }); },
      };

      // 1. Main route logic
      if (routeToggles[this.currentRoute]) {
        routeToggles[this.currentRoute]();
        if (this.currentRouteUrl) {
          this.router.navigate([this.currentRouteUrl]);
          // If navigating to a saved route, set toggles accordingly
          if (urlToggles[this.currentRouteUrl]) {
            urlToggles[this.currentRouteUrl]();
          }
        } else {
          this.handleAccessGroupNavigation();
        }
      }
      // 2. Submenu logic
      else if (routeToggles[this.currentRoute] === undefined && urlToggles[this.currentRouteUrl]) {
        urlToggles[this.currentRouteUrl]();
      } else {
        // Default: reset all toggles
        this.setMenuToggles({});
      }
    });
  }

  /**
   * To update navigation close state and send it to header component
   */
  offClickHandler(event: any) {
    const getWindowWidth = window.innerWidth;
    if (getWindowWidth <= 840) {
      if (event.target.closest('.hide-navigation')) {
        this.updateNavigationState.emit(false);
        this.appService.updateNavState(false);
      }
    }
  }

  /**
   * Helper to reset all main menu toggles
   */
  private resetAllMenuToggles() {
    this.toggleSettingsMenu = false;
    this.toggleDataPointReportingMenu = false;
    this.toggleSalesMenu = false;
    this.toggleReportsMenu = false;
    this.toggleCashierMenu = false;
    this.toggleAnalyticsMenu = false;
    this.toggleCustomReportMenu = false;
    this.toggleTruViewBalanceMenu = false;
    this.toggleDprStore = false;
    this.toggleBalancingReport = false;
    this.toggleDoubleUpReport = false;
    this.toggleDigitalReceiptsMenu = false;
  }

  toggleDropdown(type: any, subDropDown: any) {
    const dataObj: any = {};
    const selLocation = this.route.snapshot.queryParamMap.get('location');
    if (selLocation) {
      dataObj['selLocId'] = Array.isArray(selLocation) ? selLocation : [selLocation];
    } else {
      dataObj['selLocId'] = [];
    }
    this.appService.updateCompanyMenuItems(false);
    this.resetAllMenuToggles();

    switch (type) {
      case 'SETTINGS':
        this.toggleSettingsMenu = !this.toggleSettingsMenu;
        if (this.toggleSettingsMenu) {
          switch (true) {
            case this.accessGroupPermissions.includes('Company Setting'):
              this.router.navigate(['/settings/companies']);
              break;
            case this.accessGroupPermissions.includes('Datapoint Setting'):
              this.router.navigate(['/settings/dp-category']);
              break;
            case this.accessGroupPermissions.includes('Location Setting'):
              this.router.navigate(['/settings/locations']);
              break;
            case this.accessGroupPermissions.includes('Users Setting'):
              this.router.navigate(['/settings/users']);
              break;
            case this.accessGroupPermissions.includes('Connector Setting'):
              this.router.navigate(['/settings/connectors']);
              break;
            case this.accessGroupPermissions.includes('Calendar Period Setting'):
              this.router.navigate(['/settings/calendar-period']);
              break;
            case this.accessGroupPermissions.includes('Instacart Setting'):
              this.router.navigate(['/settings/instacart']);
              break;
            case this.accessGroupPermissions.includes('Category Setting'):
              this.router.navigate(['/settings/category']);
              break;
            default:
              this.router.navigate(['/settings/companies']);
          }
        }
        break;
      case 'SALES':
        this.toggleSalesMenu = !this.toggleSalesMenu;
        if (this.toggleSalesMenu) {
          this.router.navigate(['/sales/locationItems']);
        }
        break;
      case 'CASHIER':
        this.toggleCashierMenu = !this.toggleCashierMenu;
        if (this.toggleCashierMenu) {
          this.router.navigate(['/cashiers/list']);
        }
        break;
      case 'REPORTS':
        this.toggleReportsMenu = !this.toggleReportsMenu;
        if (this.toggleReportsMenu) {
          this.router.navigate(['/reports/multi-loc']);
        }
        break;
      case 'DIGITALRECEIPTS':
        this.toggleDigitalReceiptsMenu = !this.toggleDigitalReceiptsMenu;
        if (this.toggleDigitalReceiptsMenu) {
          this.router.navigate(['/digital-receipts/sent-receipts']);
        }
        break;
      case 'ANALYTICS':
        this.toggleAnalyticsMenu = !this.toggleAnalyticsMenu;
        if (this.toggleAnalyticsMenu) {
          this.router.navigate(['/analytics/query']);
        }
        break;
      case 'CUSTOM_REPORTS':
        this.toggleCustomReportMenu = !this.toggleCustomReportMenu;
        if (this.toggleCustomReportMenu) {
          this.router.navigate(['/custom-report/tax-report']);
        }
        break;
      case 'TRUVIEWBALANCE':
        this.toggleTruViewBalanceMenu = !this.toggleTruViewBalanceMenu;
        if (this.toggleTruViewBalanceMenu) {
          this.router.navigate(['/balancing/dashboard']);
        }
        break;
      case 'DATAPOINTREPORTING':
        this.toggleDataPointReportingMenu = !this.toggleDataPointReportingMenu;
        if (this.toggleDataPointReportingMenu) {
          this.toggleSubDropdown(subDropDown);
        }
        break;
      case 'DOUBLEUPREPORTS':
        this.toggleDoubleUpReport = !this.toggleDoubleUpReport;
        if (this.toggleDoubleUpReport) {
          if (
            this.accessGroupPermissions.indexOf('Double Up Report Access Group') > -1 ||
            this.role === 'Super Admin' ||
            this.role === 'Support Admin'
          ) {
            this.router.navigate(['/double-up-report/sales-metrics']);
          } else {
            this.router.navigate(['/double-up-report/milk-incentive']);
          }
        }
        break;
      case 'OTHER':
        // No toggles, just reset
        break;
      default:
      // No action
    }
  }

  /**
   * Helper to reset all sub-dropdown toggles
   */
  private resetAllSubDropdownToggles() {
    this.toggleDprStore = false;
    this.toggleDprTerminal = false;
    this.toggleDprCashier = false;
    this.toggleBalancingReport = false;
  }

  toggleSubDropdown(subDropDownName: string) {
    this.resetAllSubDropdownToggles();
    switch (subDropDownName) {
      case 'STORE':
        this.toggleDprStore = !this.toggleDprStore;
        if (this.toggleDprStore) {
          this.router.navigate(['/sales-v2/store/overview']);
        }
        break;
      case 'BALANCING':
        this.toggleBalancingReport = !this.toggleBalancingReport;
        if (this.toggleBalancingReport) {
          this.router.navigate(['/balancing/daily-reporting']);
        }
        break;
      case 'TERMINAL':
        this.toggleDprTerminal = !this.toggleDprTerminal;
        if (this.toggleDprTerminal) {
          this.router.navigate(['/sales-v2/terminal/overview']);
        }
        break;
      case 'CASHIER':
        this.toggleDprCashier = !this.toggleDprCashier;
        if (this.toggleDprCashier) {
          this.router.navigate(['/sales-v2/cashier/overview']);
        }
        break;
      default:
      // No action
    }
  }

  navigateToCompanyProfile() {
    this.router.navigate(['/settings/companies/editCompany', this.companyData.id]);
  }

  /**
   * For getting logged in user company
   */
  getUserCompany() {
    const allCompanyData = JSON.parse(localStorage.getItem('allCompanyData'));
    this.companyName = allCompanyData.name;
    this.companyData = allCompanyData;
    this.matchCompanyName = (this.companyData['name']).toLowerCase().includes("sprouts")
    this.appService.updateCompanyData(this.companyData);
    if ((allCompanyData['company_haslogo']) ||
      (allCompanyData['company_haslogo'] && this.permissions.indexOf('getCompanyLogo') > -1)) {
      this.getCompanyImage(allCompanyData.id);
    }
  }

  /**
   * To get company image from blob
   */
  getCompanyImage(companyId) {
    this.sharedService.loadImageFromBlob(companyId).subscribe((blobValue) => {
      this.createImageFromBlob(blobValue);
    }, (error) => {
      this.sharedService.serverErrorHandler(error);
    });
  }

  /**
   * For creating image from blob
   * @param image Image
   */
  createImageFromBlob(image: Blob) {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      this.imageUrl = reader.result;
      this.appService.updateCompanyLogo(this.imageUrl);
    }, false);
    if (image) {
      reader.readAsDataURL(image);
    }
  }

  /**
   * It will add the tab-menu class on sidebar on mouse over
   */
  @HostListener('mouseover') mouseover() {
    const getWindowWidth = window.innerWidth;
    if (getWindowWidth >= 841) {
      this.renderer.addClass(this.elementRef.nativeElement.children[0], this.navigation);
    }
  }

  /**
   * It will remove the tab-menu class from sidebar on mouse leave
   */
  @HostListener('mouseleave') mouseout() {
    const getWindowWidth = window.innerWidth;
    if (getWindowWidth >= 841) {
      this.renderer.removeClass(this.elementRef.nativeElement.children[0], this.navigation);
    }
    if (getWindowWidth >= 841 && getWindowWidth <= 1200) {
      this.toggleCompanyMenu = false;
    }
  }

  /**
   * closeSideBar will close the sidebar
   */
  closeSideBar() {
    this.renderer.removeClass(this.elementRef.nativeElement.children[0], this.navigation);
  }

  /**
   * To prepare company menu items
   */
  prepareGlobalFilter() {
    const globalFilter: any = [];
    const locationHeader: CompanyMenuItems = { label: '', id: null, isLocation: false, levelHeader: '', header: '', selected: false };;
    const levelsFilter = localStorage.getItem('levelsFilter') ? JSON.parse(localStorage.getItem('levelsFilter')) : '';
    const levels = levelsFilter['levels'];
    let locHier = levelsFilter['locHier'];
    if (locHier) {
      locHier = levelsFilter['locHier'];
      locHier = this.appUtils.sortAlphabetically(locHier);
    }
    locHier = this.prepareAssignedRegion(locHier, levels);
    let locations = levelsFilter['locations'] ? levelsFilter['locations'] : '';
    if (locations) {
      locations = this.appUtils.sortAlphabetically(locations);
    }

    if (locHier.length) {
      const regFilter: any = {};
      const parentIds: any = [];
      for (let i = 0; i < levels.length - 1; i++) {
        const regionHeader: CompanyMenuItems = { label: '', id: null, isLocation: false, levelHeader: '', header: '', selected: false };
        const regLevel: any = [];
        regionHeader['header'] = levels[i];
        globalFilter.push(regionHeader);
        locHier.forEach(element => {
          if (element.location_id === null && element.depth === i) {
            const region = {};
            region['label'] = element['name'];
            region['id'] = element['id'];
            region['isLocation'] = false;
            region['levelHeader'] = regionHeader['header'];
            region['selected'] = false;
            globalFilter.push(region);
            regLevel.push(region);
            parentIds.push(element['id']);
          }
        });
        regFilter[i] = regLevel;
      }
      levelsFilter['parentIds'] = parentIds;
      levelsFilter['regFilter'] = regFilter;
      localStorage.setItem('levelsFilter', JSON.stringify(levelsFilter));
    }
    locationHeader['header'] = 'Location Level';
    globalFilter.push(locationHeader);
    if (locations) {
      locations.forEach(element => {
        const location = {};
        location['label'] = element['name'];
        location['id'] = element['reg_loc_id'];
        location['isLocation'] = true;
        location['levelHeader'] = locationHeader['header'];
        globalFilter.push(location);
      });
    }
    globalFilter.forEach(element => {
      this.companyMenuItems.push(element);
    });
  }

  /**
   * To prepare assigned regions
   * @param locHier
   * @param levels
   */
  prepareAssignedRegion(locHier: any = [], levels: any = []) {
    let groupIds: any = [];
    const regions: any = [];
    if (locHier) {
      locHier.forEach(element => {
        if (element.location_id && element.depth > 0) {
          groupIds.push(element.groupid);
        }
      });

      groupIds = Array.from(new Set(groupIds));
      for (let i = levels.length - 2; i >= 0; i--) {
        const grpId = [];
        locHier.forEach(element => {
          if (element.depth === i) {
            groupIds.forEach(gid => {
              if (element.id === gid) {
                grpId.push(element.groupid);
                regions.push(element);
              }
            });
          }
        });
        groupIds = Array.from(new Set(grpId));
      }
    }
    return this.appUtils.sortAlphabetically(regions);
  }

  /**
   * To get assigned locations of  region
   *
   * @param levelsFilter
   */
  getRegionAssignedLocations(list: any, levelsFilter: any) {
    const levels = levelsFilter['levels'];
    const locHier = levelsFilter['locHier'];
    const assignedLocations: any = [];
    const finalObject: any = {};
    const assignedLocs: any = [];
    const selectedLocIds: any = [];
    let groupIds: any = [];

    groupIds.push(list['id']);
    for (let i = 0; i < levels.length - 1; i++) {
      const grpIds: any = [];
      groupIds.forEach(gid => {
        locHier.forEach(loc => {
          if (loc['location_id'] && loc['groupid'] === gid) {
            assignedLocations.push(loc);
          } else if (!loc['location_id'] && loc['groupid'] === gid) {
            grpIds.push(loc['id']);
          }
        });
      });
      groupIds = grpIds;
    }

    assignedLocations.forEach(element => {
      const assLoc = {};
      assLoc['location_id'] = element['location_id'];
      assLoc['reg_loc_id'] = element['id'];
      assLoc['name'] = element['name'];
      assLoc['depth'] = 0;
      assignedLocs.push(assLoc);
      selectedLocIds.push(element['id']);
    });
    finalObject['assignedLocs'] = assignedLocs;
    finalObject['selectedLocIds'] = selectedLocIds;
    return finalObject;
  }
}
